import React, { useCallback, useEffect, useState } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { updateTaskSimple } from '../../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { taskSimpleSelectors } from '../../../../../../../app/resource/task-simple/task-simple.selectors';
import { ITaskSimple } from '../../../../../../../app/resource/task-simple/task-simple.types';
import { useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { Status } from '../../Status';
import { IListNameProps } from './types';
import { TemporarySavedMessage } from './TemporarySavedMessage';
import { TaskBreadcrumb } from './TaskBreadcrumb';
import { Tooltip } from '../../../../../../common/Tooltip';

export const ListName: FunctionComponent<IListNameProps> = ({ taskId, boardListId, meetingId }) => {
  const dispatch = useDispatch();
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '') as ITaskSimple;

  const [checked, setChecked] = useState(task?.showInTasks === '1' ? true : false);

  useEffect(() => {
    if (task) {
      setChecked(task?.showInTasks === '1' ? true : false);
    }
  }, [task]);

  const handleChange = useCallback(() => {
    setChecked(!checked);
    dispatch(
      updateTaskSimple(task.id, {
        showInTasks: checked ? '0' : '1',
      }),
    );
  }, [checked, dispatch, task]);

  const hasBoardListAssigned = task && task.taskTypeId !== undefined && task.taskTypeId !== null;
  return (
    <>
      <div className="flex justify-between mb-3 mt-1">
        <TaskBreadcrumb meetingId={meetingId} taskId={taskId} boardListId={boardListId} />
        <TemporarySavedMessage />
      </div>
      <div className="row flex justify-between align-center mb-2">
        <div className="pl-1">
          <div className="remember-checkbox flex aic jcl">
            {/* if task is not associated to a board list, it must be an action item or we will lose it */}
            <WithTooltip
              show={!hasBoardListAssigned}
              content={'Please assign this card to a board list to be able to remove it from Action Items'}
              direction="top"
              bgColor="#13ac92"
              textColor="white"
            >
              <>
                <input
                  type="checkbox"
                  id="defaultCheckbox"
                  name="defaultCheckbox"
                  onChange={handleChange}
                  checked={checked}
                  disabled={!hasBoardListAssigned}
                />
                <label htmlFor="defaultCheckbox">Add to Action Items</label>
              </>
            </WithTooltip>
          </div>
        </div>
        <div className="flex align-center">
          {task && task.externalStatus && (
            <div className="border-2x f-1 flex mr-2" style={{ padding: 5 }}>
              <div className="bold">Wrike Status:</div>
              <span className="ml-1">{task.externalStatus}</span>
            </div>
          )}
          {taskId && <Status taskId={taskId} />}
        </div>
      </div>
    </>
  );
};

interface IActionItemCheckboxProps {
  show: boolean;
  content: string;
  direction: string;
  bgColor: string;
  textColor: string;
}

export const WithTooltip: FunctionComponent<IActionItemCheckboxProps> = ({
  children,
  show,
  content,
  direction,
  bgColor,
  textColor,
}) => {
  if (show) {
    return (
      <>
        <Tooltip content={content} direction={direction} bgColor={bgColor} textColor={textColor}>
          {children}
        </Tooltip>
      </>
    );
  } else {
    return <>{children}</>;
  }
};
